import React, { useEffect, useState } from 'react';
import LeftSideImg from '../../../assets/Game/GinRummy/images/leftImg-welcome.png'
import RightSideImg from '../../../assets/Game/GinRummy/images/rightImg-welcome.png'
import GinImage from '../../../assets/Game/GinRummy/images/ginImage.png'
import Player1 from '../../../assets/Game/GinRummy/images/Player1.png'
import Player2 from '../../../assets/Game/GinRummy/images/Player2.png'
import Versus from '../../../assets/Game/GinRummy/images/versus.png'
import './multiplayerWelcomePage.css'
import PlayGame from '../../../assets/Game/GinRummy/images/playGame.png'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";
import Button from '../../GinGame/Button/Button';
import { useFetchSearchingOnlinePlayerMutation, usePlayerToPlayerChkAddMutation } from '../../../features/P2PFeatures/P2PCheckAdd/PlayerToPlayerSlice';
import SlotCounter from "react-slot-counter";
import { useRef } from "react";
import Swal from "sweetalert2";
import { useSelector, useDispatch } from 'react-redux';
import { saveFirstPlayerCard, saveSecondPlayerCard } from '../../../features/UserFeatures/Cards/cardsSave/CardsSaveSlice';
import { set } from 'lodash';

const MultiplayerWelcomePage = () => {
    const [playerToPlayerCheckAdd] = usePlayerToPlayerChkAddMutation()
    const [postDataTOCheck] = useFetchSearchingOnlinePlayerMutation()
    const [searching, setSearching] = useState(false)
    const [connection, setConnection] = useState(null);
    const [uid2, setUid2] = useState();
    const [uName2, setUName2] = useState();
    const [roomId, setRoomId] = useState()
    const [roundCount, setRoundCount] = useState(0)
    const navigate = useNavigate()
    const accessToken = localStorage.getItem("token");
    const [msg, setMsg] = useState('')
    // const roomId = localStorage.getItem('roomId');
    let userId = localStorage.getItem("userId");
    console.log("userIdCheck", userId)
    const firstPlayerCardsData = useSelector((state) => state);

    const dispatch = useDispatch()

    console.log("firstPlayerCardsData", firstPlayerCardsData?.playerCardDetail?.list)

  


    useEffect(() => {
        try {
            const connect = new HubConnectionBuilder()
                .withUrl(`${process.env.REACT_APP_API_KEY}/gameHub`, {
                    accessTokenFactory: () => accessToken,
                    // skipNegotiation: true,
                    transport: HttpTransportType.LongPolling,
                })
                .withAutomaticReconnect()
                .build();
            setConnection(connect);

        } catch (err) {
            console.log("invoking Error", err);
        }
    }, []);


    useEffect(() => {
        if (connection && uName2) {
            connection
                .start()
                .then(() => {
                    invokeConnection();
                })
                .catch((error) => console.log(error));
        }
        // getData();
    }, [connection, uName2]);

    useEffect(() => {
        if (connection) {
            connection.on("ReceiveMessage", (user, message) => {
                console.log("ReceiveMessage", user, "sssss", message)
                const messageForUserRoomId = message.split(',')
                console.log("messageForUser", messageForUserRoomId, "hgggg", `${messageForUserRoomId[0]}${messageForUserRoomId[1]}`)
                console.log("messsaaggeee", message)
                if (message == 'Yes Confirmed') {
                    navigate('/ginGameMultiplayer/multiplayer_Game')
                    localStorage.setItem("intitialMove",true)
                }
                else if (message == 'User not available! keep searching...') {
                    setMsg(message)
                }
                else {
                    Swal.fire({
                        title: 'Success',
                        type: 'success',
                        text: `${messageForUserRoomId[0]}${messageForUserRoomId[1]}`,
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: 'Play',
                        cancelButtonText: "No!",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    }).then(function (res) {
                        console.log("rekkkkkkk", res)
                        if (res.isConfirmed) {
                            dispatch(saveFirstPlayerCard([]))
                            console.log("messageForUserRoomId[3]",messageForUserRoomId[3])
                            connection.invoke("SendMessageToUser", messageForUserRoomId[3], "Yes Confirmed")
                            const SendOppoCardToRoom = connection.invoke("SendOppoCardToRoom", messageForUserRoomId[2], userId2, `${messageForUserRoomId[0]}${messageForUserRoomId[1]}`, roundCount).then((res) => {
                                console.log("resresres", res?.data);
                                localStorage.setItem("roomId", res?.data?.roomId);
                                dispatch(saveFirstPlayerCard(res))
                                localStorage.setItem("intitialMove",true)
                            })
                            if(res?.data?.firstPlayerCards?.length == 0){
                                console.log("error in opponent card from signal R method")
                                Swal.fire({
                                    title: 'warning',
                                    type: 'warning',
                                    text: "Server Error",
                                    cancelButtonText: "ok!",
                                })
                            }
                            console.log("SendOppoCardToRoom", SendOppoCardToRoom)

                            const searchingOffData = {
                                "UserId": userId,
                                "IsOnline": false,
                                "IsSearching": false,
                                "lastGameEnd": new Date()
                            }

                            setTimeout(() => {
                                const searchingOff = async () => {
                                    const playerToCheck = await playerToPlayerCheckAdd(searchingOffData)
                                    console.log("playerToCheckplayerToCheck", playerToCheck)
                                    navigate('/ginGameMultiplayer/multiplayer_Game')
                                }
                                searchingOff()
                            }, [500])
                        }

                        else if (res?.isDismissed) {
                            console.log("isDismissed", res)
                            const dismissedRes = connection.invoke("SendMessageToUser", messageForUserRoomId[3], "User not available! keep searching...")
                            console.log("dismissedRes", dismissedRes)
                            navigate('/ginGame')
                            localStorage.removeItem("roomId")
                            localStorage.removeItem('userName2')
                            localStorage.removeItem('userId2')
                            localStorage.removeItem('roundCount')
                        }
                    });
                    console.log("ReceiveMessageTOUser", user, message)
                }
            });
        }
    }, [connection])

    useEffect(() => {
        playerToAdd()

    }, [connection])


    // const userId = localStorage.getItem("userId")
    const data =
    {
        "UserId": userId,
        "IsOnline": true,
        "IsSearching": true,
        "lastGameEnd": new Date()
    }
    const counterRef = useRef(null);

    const playerToAdd = async () => {
        console.log("dataTOCheckj", data)
        const playerToCheck = await playerToPlayerCheckAdd(data)
        console.log("playerToCheck", playerToCheck)
        if (playerToCheck?.data?.status === 200) {
            const postDataTOCheckData = await postDataTOCheck(userId)
            if (postDataTOCheckData?.data?.data?.length == 0) {
                const intervalData = setInterval(async () => {
                    const postDataTOCheck = await postDataTOCheck(userId)
                }, 1000);
                clearInterval(intervalData)
            }
            else {
                setMsg('No user found ! try again')
            }
            if (postDataTOCheckData?.data?.status === 200) {
                // console.log("postDataToChecKData", item.userId)
                const res = postDataTOCheckData?.data?.data?.map((d) => d)
                console.log("resrress", res[0])
                if (res[0]?.userName) {
                    const uName2 = localStorage.setItem("userName2", res[0]?.userName)
                    const uid22 = localStorage.setItem("userId2", res[0]?.userId)
                    console.log("uid22", uid22, uName2)
                    setUid2(res[0]?.userId)
                    setUName2(res[0]?.userName)
                    setMsg('')
                }
                else {
                    setMsg('No user found ! try again')
                }
            }
        }
    }

    const userId2 = localStorage.getItem("userId2")
    const userName2 = localStorage.getItem("userName2")
    const userName = localStorage.getItem("userName")

    console.log("object", userName, "uid2", userId2, userName2, "uid2--->>>", uid2, uName2)

    const gameNames = {
        RoomId: "", // Replace with the actual room ID
        GameName: "GinRummy",
        UserId1: userId,
        UserName1: userName,
        UserId2: userId2,
        UserName2: uName2, //1D0BBABA-CC86-4457-B8FC-9E4E9C7B8EEA
        RoundCount: 0
    };

    console.log("NamessNamess", gameNames)
    async function invokeConnection() {
        async function start() {
            try {
                await connection.start();
                console.log("SignalR Connected.");
            } catch (err) {
                console.log(err);
                setTimeout(start, 500);
            }
        };
        connection.onclose(async () => {
            await start();
        });
        try {
            console.log("connecion", connection)
            console.log("gameNames", gameNames)
            const data = await connection.invoke("CardDistributionforP2PGin", gameNames);
            const resId = localStorage.setItem("roomId", data.roomId)
            console.log("dataforP2p2", data, "----")

            setRoomId(data?.roomId)
            dispatch(saveFirstPlayerCard(data?.data))
        }

        catch (err) {
            console.error("Error invoking CardDistributed: " + err);
        }
    }

    console.log("userId", userId)
    console.log("userId2", userId2)
    const searchingOffData = {
        "UserId": userId,
        "IsOnline": false,
        "IsSearching": false,
        "lastGameEnd": new Date()
    }

    const startGameHandler = async () => {
        const rId = localStorage.getItem("roomId")
        console.log("dsdsdsdsdssdds", rId, roomId)
        const message1 = `Hi ${userName2}, ${userName} wants to play game with you ,${rId},${userId}`
        try {

            const res = await connection.invoke("SendMessageToUser", uid2, message1)
            console.log("message sent res", res)
        }
        catch (err) {
            console.log(err)
        }
        counterRef.current?.startAnimation();
        setSearching(true)
        const playerToCheck = await playerToPlayerCheckAdd(searchingOffData)
        console.log("user1Check", playerToCheck)
        // console.log("datatatatta", data)

        // navigate("/ginGameMultiplayer/multiplayer_Game")
    }


    return (
        <>
            <section className='wrapper ginWelcomePage'>
                <div className='bgWelcome'>
                    <div className='main-section'>

                        <Container fluid>
                            <Row className=' justify-content-center'>
                                <Col sm={12} className='text-center img-fluid'>
                                    <img src={GinImage} style={{ width: '8%' }} className='img-fluid' alt="Gin game Image" />
                                </Col>

                                <Col sm={12} md={11} lg={10} className='align-items-center d-flex flex-column justify-content-center'>
                                    <Row className='align-items-center justify-content-center g-md-5'>
                                        <Col sm={4} md={4} lg={3} xl={4} className=' align-items-center d-flex flex-column justify-content-center'>
                                            <div className='userImageBg'>
                                                <img src={Player1} className='img-fluid' alt="Gin game Image" />
                                            </div>
                                            <div className='playerName'>
                                                <p className='text-capitalize'>{userName}</p>
                                            </div>

                                        </Col>
                                        <Col sm={4} md={2} lg={2} xl={4} className='text-center'>
                                            <img src={Versus} className='img-fluid' alt="Gin game Image" />
                                        </Col>

                                        <Col sm={4} md={4} lg={3} xl={4} className=' align-items-center d-flex flex-column justify-content-center'>
                                            <div className='userImageBg'>

                                                <SlotCounter
                                                    ref={counterRef}
                                                    duration={searching ? 0.6 : 0}
                                                    style={{ height: "300px" }}
                                                    value={[
                                                        <img
                                                            style={{ height: "240px" }}
                                                            className="item img-fluid"
                                                            src={Player2}
                                                        />,
                                                    ]}
                                                    dummyCharacters={[
                                                        <img
                                                            className="item img-fluid"
                                                            src={Player1}
                                                        />,
                                                        <img
                                                            className="item img-fluid"
                                                            src={Player2}
                                                        />,
                                                        <img
                                                            className="item img-fluid"
                                                            src={Player1}
                                                        />,
                                                    ]}
                                                />
                                                {/* <img src={Player2} className='img-fluid' alt="Gin game Image" /> */}
                                            </div>
                                            <div className='playerName'>
                                                <p className='text-capitalize'>{msg != 'No user found ! try again' ? userName2 : "Player2"}</p>
                                            </div>
                                        </Col>

                                    </Row>
                                </Col>

                            </Row>
                            <Row className='justify-content-center mt-4'>
                                <Col md={6} className='align-items-center d-flex flex-column justify-content-center'>
                                    <Button src={PlayGame} btnName={msg ? `Search Again` : `Start Game`} onClick={msg ? playerToAdd : startGameHandler} />
                                    <h3 className='text-white'>{msg}</h3>
                                    {/* <Button src={PlayGame} onClick={startGameHandler} btnName="Start Game" /> */}
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <img src={LeftSideImg} className='LeftSideImg' alt="" />
                    <img src={RightSideImg} className="RightSideImg" alt="" />
                </div>
            </section>
        </>
    )
}

export default MultiplayerWelcomePage;